"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const universal_base64_1 = require("universal-base64");
/**
 * Check if token is valid
 */
function checkTokenValid(token) {
    const tokenParts = token.split('.');
    const tokenPayload = JSON.parse(universal_base64_1.decode(tokenParts[1]));
    const timestamp = tokenPayload.exp;
    const expDate = new Date(timestamp * 1000);
    const todayDate = new Date();
    return expDate > todayDate;
}
exports.default = checkTokenValid;
//# sourceMappingURL=checkTokenValid.js.map